import {
  backgroundColorCss,
  mobileBackgroundColorCss,
} from 'common/utils/styleUtilsNew'
import styled, { css } from 'styled-components'

const beforeAfter = css`
  content: ' ';
  height: 30px;
  width: 2px;
  position: absolute;
  top: -2px;
  left: 12px;
  right: 0;
  bottom: 0;

  background-color: #333;
  box-shadow: 0px 0px 1px #fff;
`

interface PopupCloseButtonUiProps {
  backgroundColor?: string
  mobileBackgroundColor?: string
}

export const PopupCloseButtonUi = styled.button.attrs(() => ({
  'data-testid': 'popup-close-icon',
}))<PopupCloseButtonUiProps>`
  position: absolute;
  right: 15px;
  top: 15px;
  width: 30px;
  height: 30px;
  z-index: 1;
  background: transparent;
  text-shadow: 1px 1px 0 rgba(0, 0, 0, 0.7);
  transition: opacity 250ms ease-in-out;
  cursor: pointer;
  border: none;

  &:hover {
    opacity: 0.5;
  }

  &:before {
    ${beforeAfter};
    ${backgroundColorCss};

    transform: rotate(45deg);

    ${p => p.theme.phone} {
      ${mobileBackgroundColorCss};
    }

    ${p =>
      p.theme.isEditorMobileMode &&
      css`
        ${mobileBackgroundColorCss};
      `}
  }

  &:after {
    ${beforeAfter};
    ${backgroundColorCss};

    transform: rotate(-45deg);

    ${p => p.theme.phone} {
      ${mobileBackgroundColorCss};
    }

    ${p =>
      p.theme.isEditorMobileMode &&
      css`
        ${mobileBackgroundColorCss};
      `}
  }
`
